export const OperationDataReportIssueTypeProvider = () => {
    return [
        "IssueWithOperationData",
        "IssueWithOperationDataCampaignInformation",
        "IssueWithOperationDataContact",
        "IssueWithOperationDataWarehouseAddress",
        "IssueWithOperationDataArticleDatabase",
    ];
};
